import { apiClient } from '../config'

import type { UnhealthyCustomersResponse } from '../types'

export const unhealthyCustomersService = {
  getUnhealthyCustomers: async (): Promise<UnhealthyCustomersResponse> => {
    const response = await apiClient.get<UnhealthyCustomersResponse>('/admin/unhealthy-customers')
    return response.data
  },
}
